<!-- Theme CSS -->
<link href="/assets/css/style.css" rel="stylesheet">
<link href="/fr/assets/css/style.css" rel="stylesheet">
<link href="/en/assets/css/style.css" rel="stylesheet">
<link href="/es/assets/css/style.css" rel="stylesheet">
<link href="/pt/assets/css/style.css" rel="stylesheet">
<link href="/ko/assets/css/style.css" rel="stylesheet">
<style>
  #about img {
    object-fit: contain;
    width: 80%;
}
</style>
<header>
  <nav class="navbar navbar-custom" role="navigation">
    <div id='lang' class="homemenu" style="float: right;margin:10px 40px 0 0;">
      <a (click) = "registerClick()" i18n>REGISTER |</a>
      <a (click) = "loginClick()" i18n>SIGN IN</a>
    </div>
    <lang-change></lang-change>
  </nav>
</header>
<section class="intro landing-high">
  <div class="intro-body">
    <div class="container">
      <div class="row">
          <div class="col-md-12 brand-heading-text">
              <h5 class="brand-heading" i18n>SDG 6 Policy Support System (SDG-PSS)</h5>
            <p i18n>The SDG-PSS is designed as part of the project <strong>‘​Water in the World We Want​’</strong> to enable water experts, researchers, and government actors to collaborate and produce national-level evidence on the enabling environment to achieve SDG 6.</p>
          </div>
      </div>
      <div class="row" style="text-align:center">
        <div class="col-md-1"></div>
        <div class="col-md-10">
          <!-- YouTube Embed for non-English languages -->
          <iframe *ngIf="isYouTubeEmbed" class="reduce-height" width="100%" height="480" [src]="videoUrl" frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen>
          </iframe>
          <!-- Local video for English -->
          <video *ngIf="!isYouTubeEmbed" width="100%" class="reduce-height" height="480" controls autoplay muted loop>
            <source [src]="videoUrl" type="video/mp4">
            Your browser does not support the video tag.
          </video>
        </div>
        <div class="col-md-1"></div>
      </div>
      <div class="row">
        <div class="col-md-1 col-lg-2">
        </div>
        <div class="col-lg-8 col-md-9 col-sm-12 col-xs-12 login-buttons">
          <div class="align-btn center-text">
            <div class="two-btn" (click)= "registerClick()" i18n>Register</div>
            <div class="two-btn" (click)= "loginClick()" i18n>Sign in</div>
        </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- About Section -->
<footer id="about" class="content-section">
  <div class="container">
    <div class="row">
        <!-- <div class="col-lg-12">
            <div class="topbar-logo">
              <img src="./assets/img/UNU-INWEH_LOGO.png" class="img-responsive logo">
              <img src="./assets/img/logo1.gif" class="img-responsive logo1">
              <img src="./assets/img/logo2.jpg" class="img-responsive logo1">
              <img src="./assets/img/logo2.png" class="img-responsive logo2">



            </div>
        </div> -->
        <div class="col-lg-3 col-md-3 col-sm-12"><img src="./assets/img/UNU-INWEH_LOGO.png" height="150px" width="auto"></div>
        <div class="col-lg-3 col-md-3 col-sm-12"><img src="./assets/img/logo1.gif" height="150px" width="auto"></div>
        <div class="col-lg-3 col-md-3 col-sm-12"><img src="./assets/img/logo2.jpg" height="150px" width="auto"></div>
        <div class="col-lg-3 col-md-3 col-sm-12"><img src="./assets/img/logo2.png" height="150px" width="auto"></div>
    </div>
  <div class="row"><div class="col-lg-12"><p style="padding:30px 0 10px 35px; display:block" i18n>© UNU-INWEH and UNOSD 2017</p></div></div>
    </div>
</footer>



// WEBPACK FOOTER //
// ./src/app/landing/landing.component.html